<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
#app {
  // font-family:"微软雅黑" !important;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  // "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif
}

:root {
  --main-blue: #007AFB;
  // --primary-color: #007AFB;
}

.sm-color-blue {
  color: var(--main-blue);
}

body {
  margin: 0px;
  overflow: hidden;
  min-width: 1024px;
  /* 当显示dialog的时候 body 默认多出了一个 paading-right */
  padding-right: 0px !important;
}

/*滚动条样式*/
// &::-webkit-scrollbar {
//   width: 0;
// }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}






/* 所有表*/
// 表 【滚动条样式】
&::-webkit-scrollbar-thumb {
  background-color: #f1f3f4;
}

// 所有表头背景色
// .vxe-header--column {
//   background-color: #f6f8fa;
// }

// // 所有表内容高度
// .vxe-table--render-default .vxe-body--column {
//   padding: 10px 0px !important;
// }

// // 所有表内容样式
// .vxe-table--render-default .vxe-cell {
//   white-space: unset;
// }

// .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
//   padding: 10px 0px !important;
// }

// // 每一行的高
// .vxe-table--render-default .vxe-body--column.col--ellipsis {
//   height: 35px;
// }



/* 底 */
// 底 【页的样式】
.el-pagination {
  margin-top: 5px;
  padding: 0px;
  line-height: 36px;
}

.el-button--primary {
  background-color: var(--main-blue) !important;
  border-color: var(--main-blue) !important;
  color: #fff !important;
}

// 底 【页的颜色】
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: var(--main-blue);
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--main-blue);
  color: #ffffff;
}


/* 头部样式 */
// 所有输入框高
.el-input__inner {
  height: 36px;
  line-height: 36px;
}

// .el-button {
//   padding: 10px 8px;
// }

// 搜索按钮背景色
.el-input-group__append {
  background-color: #ffffff;

}

// 选中状态颜色
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: var(--main-blue);
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--main-blue);
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--main-blue);
  border-color: var(--main-blue);
}


// 所有头时间样式
// .el-range-editor.el-input__inner {
//   padding: 0px 10px;
// }

.el-date-editor--datetimerange.el-input__inner {
  width: 330px;
}

// .el-date-editor .el-range__icon {
//   line-height: 34px;
// }

.el-date-editor .el-range-separator {
  width: 25px;
  // font-size: 12px;
  // line-height: 36px;
}

.el-date-editor .el-range__close-icon {
  display: none; //清空隐藏
}

// .el-date-editor .el-range-input {
//   width: 130px; // 选择时间宽
// }



/* 对话框样式 */
.el-dialog__header {
  padding: 0px;
}

.el-dialog {
  border-radius: 4rem;
}

.el-dialog__body {
  padding: 0px;
}

.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: var(--main-blue);
}

.el-dialog__headerbtn {
  right: 30px;
}

// 全局树形控件样式修改
.el-tree-node__content:hover {
  background-color: #fff9f9 !important;
}

.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  border-radius: 3px;
  // background: #fbf0f0;
  background-color: transparent;
  color: var(--main-blue);
  font-weight: 600;
}

// .el-tree-node__content {
//   height: 32px !important;
//   color: #000;
//   padding: 0 !important;
// }

//虚线添加开始===========
// .el-tree>.el-tree-node:after {
//   border-top: none;
// }

// .el-tree-node {
//   position: relative;
//   padding-left: 0;
// }

//节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
// .el-tree-node__expand-icon.is-leaf {
//   display: none;
// }

// .el-tree-node__children {
//   padding-left: 16px;
// }

// .el-tree-node :last-child:before {
//   height: 38px;
// }

// .el-tree>.el-tree-node:before {
//   border-left: none;
// }

// .el-tree>.el-tree-node:after {
//   border-top: none;
// }

.el-tree-node__content>.el-tree-node__expand-icon {
  padding: 0 !important;
}

// .el-tree-node:before {
//   content: "";
//   left: -10px;
//   position: absolute;
//   right: auto;
//   border-width: 1px;
// }

// .el-tree-node:after {
//   content: "";
//   left: -10px;
//   position: absolute;
//   right: auto;
//   border-width: 1px;
// }

// .el-tree-node:before {
//   border-left: 1px solid #cbcdce;
//   bottom: 0px;
//   height: 100%;
//   top: -20px;
//   width: 1px;
// }

// .el-tree-node:after {
//   border-top: 1px solid #cbcdce;
//   height: 20px;
//   top: 17px;
//   width: 10px;
// }

//虚线添加结束===========


// 单选【复选】按钮颜色样式
.el-radio__input.is-checked .el-radio__inner {
  border-color: var(--main-blue);
  background: var(--main-blue);
}

.el-radio__input.is-checked+.el-radio__label {
  color: var(--main-blue);
}

.el-radio__inner:hover {
  border-color: var(--main-blue);
}

.el-checkbox__inner:hover {
  border-color: var(--main-blue);
}




// 树形添加样式
.el-dropdown-menu__item:not(.is-disabled):hover {
  // background: #fbf0f0;
  color: var(--main-blue);
}




// 单选框样式
.el-input__icon {
  line-height: 36px;
}

.el-select-dropdown__item.selected {
  color: var(--main-blue);
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--main-blue);
}

.el-select .el-input__inner:focus {
  border-color: var(--main-blue);
}




// 所有element 颜色样式
.el-input__inner:focus {
  border-color: var(--main-blue);
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--main-blue);
}

.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: var(--main-blue);
}

.el-date-table td.today span {
  color: var(--main-blue);
}

.el-date-table td.available:hover {
  color: var(--main-blue);
}


.el-button--text {
  color: var(--main-blue);
}

.el-button--text:focus,
.el-button--text:hover {
  color: var(--main-blue);
}

.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #FFF;
  border-color: var(--main-blue);
  color: var(--main-blue);
}

.el-time-panel__btn.confirm {
  color: var(--main-blue);
}

.el-date-table td.current:not(.disabled) span {
  color: #FFF;
  background-color: var(--main-blue);
}

.el-month-table td .cell:hover {
  color: var(--main-blue);
}

.el-month-table td.today .cell {
  color: var(--main-blue);
}

.el-month-table td.end-date .cell,
.el-month-table td.start-date .cell {
  color: #FFF;
  background-color: var(--main-blue);
}



.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--main-blue);
  border-color: var(--main-blue);
}

//  .el-radio-group {
.el-radio-button__inner {
  background: #fff !important;
  color: #606266 !important;
  border: 1px solid #dcdfe6 !important;
  transition: all 0.2s !important;
}

.el-radio-button__orig-radio:checked+.el-radio-button__inner,
.el-radio-button.is-active .el-radio-button__inner {
  color: #6396fc !important;
  background: #fff !important;
  border-color: #6396fc !important;
  box-shadow: none !important;
}

.el-radio-button__inner:hover {
  color: #6396fc !important;
  border-color: #6396fc !important;
  background: #fff !important;
}

// }</style>



// WEBPACK FOOTER //
// src/App.vue